import { render, staticRenderFns } from "./DeferredStarsIndexComponent.vue?vue&type=template&id=1850e332"
import script from "./DeferredStarsIndexComponent.vue?vue&type=script&lang=js"
export * from "./DeferredStarsIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports